import { gql } from '@apollo/client';
import type { RunningWithoutDriverVehiclesQuery, RunningWithoutDriverVehiclesQueryVariables } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';
import TimeZone from '../../request/Timezone';

// Operation is picked up by graphql-codegen (see codegen.ts `documents`), which generates
// `RunningWithoutDriverVehiclesQuery`/`...Variables` consumed below — no hand-written contract types.
const RUNNING_WITHOUT_DRIVER_VEHICLES = gql(`
  query runningWithoutDriverVehicles($timezone: String!, $groupIds: [String], $page: Int, $size: Int) {
    runningWithoutDriverVehicles(timezone: $timezone, groupIds: $groupIds, page: $page, size: $size) {
      page {
        number
        size
        totalElements
        totalPages
      }
      content {
        vehicle {
          id
          licensePlate
          alias
          groupPath
          groups {
            id
            name
          }
        }
        unassignedTripCount
        totalTripCount
        unnamedClusters {
          id
          photoCount
          thumbnailUrl
          lastCapturedAt
        }
      }
    }
  }
`);

class RunningWithoutDriverRequester {
  // The contract pages by `unassignedTripCount` desc over a fixed 14-day window resolved server-side;
  // the FE supplies only the client timezone, optional group filter, and pagination.
  public getRunningWithoutDriverVehicles = (
    variables: Omit<RunningWithoutDriverVehiclesQueryVariables, 'timezone'> = {}
  ): Promise<RunningWithoutDriverVehiclesQuery['runningWithoutDriverVehicles']> =>
    graphQLRequester
      .query<RunningWithoutDriverVehiclesQuery, RunningWithoutDriverVehiclesQueryVariables>({
        query: RUNNING_WITHOUT_DRIVER_VEHICLES,
        variables: { timezone: TimeZone.getTimezone(), ...variables },
      })
      .then(({ runningWithoutDriverVehicles }) => runningWithoutDriverVehicles);
}

export default RunningWithoutDriverRequester;
